var map = {
	"./en": [
		129,
		7
	],
	"./en/": [
		129,
		7
	],
	"./en/index": [
		129,
		7
	],
	"./en/index.js": [
		129,
		7
	],
	"./ne": [
		130,
		8
	],
	"./ne/": [
		130,
		8
	],
	"./ne/index": [
		130,
		8
	],
	"./ne/index.js": [
		130,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 381;
module.exports = webpackAsyncContext;